module.exports = __webpack_public_path__ + "img/ic_questions_other_selected.21c01109.svg";